import React from 'react'
import PropTypes from 'prop-types'
import { Button, OverlayTrigger, Popover } from 'react-bootstrap'

const HelpPopover = ({ id, title = 'Help', children }) => {
  const overlayContent = (
    <Popover id={id} title={title}>
      {children}
    </Popover>
  )

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={overlayContent}
    >
      <Button variant="link">
        <span className="fa-solid fa-info-circle" /> Help
      </Button>
    </OverlayTrigger>
  )
}

HelpPopover.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.element.isRequired,
}

export default HelpPopover
